import classNames from 'classnames';
import styles from './FJResourcePanel.module.less';
import FJVirtualizedMixView from '../FJVirtualizedMixView/FJVirtualizedMixView';
import FJImage from '../FJImage/FJImage';
import FJButton, { FJButtonType } from '../FJButton/FJButton';
import { useMemo, useCallback } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJLoading from '../FJLoading/FJLoading.jsx';
import FJOppsIcon from '../../../assets/svg/oops.svg?react';
import FJConfig from '../../../config/FJConfig.js';

const FJResourcePanel = props => {
    const {
        list,
        sizeList,
        renderItem,

        rowSpace = 8,
        verticalSpace = 8,
        row = 2,
        viewWidth = 166,

        className,
        scrollerClassName,

        isShowLoading = false,
        isShowError = false,
        isShowEmpty = false,

        isTextToImageHistory = false,
        isImageToImageHistory = false,
        onClickRetry,
    } = props;

    const _renderEmpty = useMemo(() => {
        let imgSrc = FJConfig.usePhotoTextToImageHistoryNullPng;
        let desc = FJLocalStore._('no-AI-images-yet-generate-AI-images-from-text-right-now');
        let btnText = 'start-now';
        let jumpUrl = 'apply/text-to-image';

        if (isImageToImageHistory) {
            imgSrc = FJConfig.usePhotoImageToImageHistoryNullPng;
            desc = FJLocalStore._('no-AI-images-yet-generate-AI-images-from-photos-right-now');
            jumpUrl = 'apply/image-to-image';
        }
        if (isTextToImageHistory || isImageToImageHistory) {
            return (
                <div className={styles.text_to_image_history_empty}>
                    <FJImage
                        isShowLoading={true}
                        imgSrc={imgSrc}
                        boxClassName={styles.text_to_image_history_empty_img}
                    />
                    <div className={styles.text_to_image_history_empty_text}>{desc}</div>
                    <FJButton
                        className={styles.text_to_image_history_empty_btn}
                        type={FJButtonType.GRADIENT}
                        text={btnText}
                        onClick={() => {
                            window.open(jumpUrl, '_blank');
                        }}
                    />
                </div>
            );
        }
        return <div className={styles.empty}>{<div className={styles.empty_text}>No data</div>}</div>;
    }, [isTextToImageHistory, isImageToImageHistory]);

    const _renderError = useCallback(() => {
        return (
            <div className={styles.status_box}>
                <FJOppsIcon />
                <div className={styles.status_text}>{FJLocalStore._('failed-to-load-image-please-try-again')}</div>
                <FJButton text='retry' onClick={onClickRetry} className={styles.retry_btn} />
            </div>
        );
    }, []);

    const _renderLoading = useCallback(() => {
        return (
            <div className={styles.status_box}>
                <FJLoading strokeColor='#a8acbc' />
            </div>
        );
    }, []);

    return (
        <div className={classNames(styles.resource_panel, className)}>
            <FJVirtualizedMixView
                className={classNames(styles.virtualized_mix_view, scrollerClassName)}
                list={list}
                renderItem={renderItem}
                childrenSizeList={sizeList}
                viewWidth={viewWidth}
                row={row}
                rowSpace={rowSpace}
                verticalSpace={verticalSpace}
            />
            {isShowLoading && _renderLoading()}
            {isShowError && _renderError()}
            {isShowEmpty && _renderEmpty}
        </div>
    );
};

export default FJResourcePanel;
